/**
 * Episode Page - Audio Player & Media Toggle
 */

document.addEventListener("DOMContentLoaded", (event) => {
  let currentPlayer = null;

  const playerElement = document.querySelector('.player');
  const mainAudio = playerElement?.dataset.mainAudio;
  const hasMultipleParts = playerElement?.dataset.hasMultipleParts === 'true';
  const baseTitle = playerElement?.dataset.title || 'Sismique';
  const coverUrl = playerElement?.dataset.cover || '';

  const initPlayer = (audioUrl, partLabel = '') => {
    if (currentPlayer) {
      currentPlayer.destroy();
    }

    const fullTitle = partLabel ? baseTitle + ' - ' + partLabel : baseTitle;

    currentPlayer = new Shikwasa.Player({
      container: document.querySelector('.player'),
      fixed: {
        type: 'static'
      },
      audio: {
        title: fullTitle,
        artist: 'Sismique',
        cover: coverUrl,
        src: audioUrl,
      },
      preload: 'metadata',
      controls: ['play', 'progress', 'time', 'volume']
    });
  };

  if (mainAudio) {
    initPlayer(mainAudio, hasMultipleParts ? 'Première partie' : '');
  }

  const createCheckIcon = () => {
    const checkIcon = document.createElement('span');
    checkIcon.className = 'check-icon relative z-10 w-6 h-6 bg-black text-primary font-bold rounded-full flex items-center justify-center text-sm animate-pulse';
    checkIcon.innerHTML = `
        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
        </svg>
      `;
    return checkIcon;
  };

  const createPlayIcon = () => {
    const playIcon = document.createElement('span');
    playIcon.className = 'relative z-10 w-6 h-6 bg-red-600 text-white rounded-full flex items-center justify-center transition-all duration-300 group-hover:bg-black group-hover:text-red-600 group-hover:scale-110';
    playIcon.innerHTML = `
        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M8 5v14l11-7z"/>
        </svg>
      `;
    return playIcon;
  };

  const createPodcastIcon = () => {
    const podcastIcon = document.createElement('span');
    podcastIcon.className = 'relative z-10 w-6 h-6 bg-black text-primary font-bold rounded-full flex items-center justify-center text-sm';
    podcastIcon.innerHTML = `
        <svg  class="w-4 h-4" xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-headphones"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 13m0 2a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2z" /><path d="M15 13m0 2a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2z" /><path d="M4 15v-3a8 8 0 0 1 16 0v3" /></svg>

      `;
    return podcastIcon;
  };

  const cleanButtonIcons = (button) => {
    if (!button) return;

    const iconsToRemove = button.querySelectorAll('.check-icon, span[class*="bg-red-600"], span[class*="bg-black"]');
    iconsToRemove.forEach(icon => icon.remove());
  };

  const addIconToButton = (button, icon) => {
    if (!button) return;

    const textSpans = button.querySelectorAll('span');
    const textSpan = Array.from(textSpans).find(span =>
      span.textContent && !span.classList.contains('check-icon') &&
      !span.classList.contains('bg-red-600') && !span.classList.contains('bg-black')
    );

    if (textSpan) {
      button.insertBefore(icon, textSpan);
    } else {
      button.prepend(icon);
    }
  };

  const audioVersionSelect = document.getElementById('audio-version-select');
  if (audioVersionSelect) {
    audioVersionSelect.addEventListener('change', (event) => {
      const selectedOption = event.target.selectedOptions[0];
      const newAudioUrl = selectedOption.dataset.audioUrl;
      const partLabel = selectedOption.dataset.audioLabel;

      if (newAudioUrl) {
        initPlayer(newAudioUrl, partLabel);
      }
    });
  }

  const youtubeContainer = document.getElementById('youtube-container');
  const audioContainer = document.getElementById('audio-container');
  const videoModeBtn = document.getElementById('video-mode-btn');
  const audioModeBtn = document.getElementById('audio-mode-btn');
  const youtubePlaceholder = document.getElementById('youtube-placeholder');
  const youtubeIframe = document.getElementById('youtube-iframe');

  if (videoModeBtn && audioModeBtn) {
    videoModeBtn.addEventListener('click', () => {
      if (videoModeBtn.classList.contains('active')) {
        return;
      }

      videoModeBtn.style.transform = 'scale(0.95)';
      setTimeout(() => {
        videoModeBtn.style.transform = 'scale(1)';
      }, 150);

      videoModeBtn.classList.remove('bg-white/10', 'text-white', 'hover:bg-gradient-to-r', 'hover:from-red-500', 'hover:to-red-600', 'hover:border-red-400');
      videoModeBtn.classList.add('bg-gradient-to-r', 'from-primary', 'via-yellow-300', 'to-primary', 'text-black', 'active', 'shadow-lg');

      audioModeBtn.classList.remove('bg-gradient-to-r', 'from-primary', 'via-yellow-300', 'to-primary', 'active', 'text-black', 'shadow-lg');
      audioModeBtn.classList.add('bg-white/10', 'text-white', 'hover:bg-gradient-to-r', 'hover:from-red-500', 'hover:to-red-600');

      cleanButtonIcons(videoModeBtn);
      cleanButtonIcons(audioModeBtn);

      const videoCheckIcon = createCheckIcon();
      const audioPodcastIcon = createPodcastIcon();

      addIconToButton(videoModeBtn, videoCheckIcon);
      addIconToButton(audioModeBtn, audioPodcastIcon);

      const videoTextSpan = videoModeBtn.querySelector('span:last-child');
      const audioTextSpan = audioModeBtn.querySelector('span:last-child');

      if (videoTextSpan) videoTextSpan.textContent = 'Vidéo';
      if (audioTextSpan) audioTextSpan.textContent = 'Audio';

      if (youtubeContainer) {
        youtubeContainer.style.opacity = '0';
        youtubeContainer.classList.remove('hidden');
        setTimeout(() => {
          youtubeContainer.style.opacity = '1';
        }, 50);
      }

      if (audioContainer) {
        audioContainer.style.opacity = '0';
        setTimeout(() => {
          audioContainer.classList.add('hidden');
        }, 300);
      }

      if (currentPlayer) {
        currentPlayer.pause();
      }
    });

    audioModeBtn.addEventListener('click', () => {
      if (audioModeBtn.classList.contains('active')) {
        return;
      }

      audioModeBtn.style.transform = 'scale(0.95)';
      setTimeout(() => {
        audioModeBtn.style.transform = 'scale(1)';
      }, 150);

      audioModeBtn.classList.remove('bg-white/10', 'text-white', 'hover:bg-gradient-to-r', 'hover:from-red-500', 'hover:to-red-600');
      audioModeBtn.classList.add('bg-gradient-to-r', 'from-primary', 'via-yellow-300', 'to-primary', 'text-black', 'active', 'shadow-lg');

      videoModeBtn.classList.remove('bg-gradient-to-r', 'from-primary', 'via-yellow-300', 'to-primary', 'active', 'text-black', 'shadow-lg');
      videoModeBtn.classList.add('bg-white/10', 'text-white', 'hover:bg-gradient-to-r', 'hover:from-red-500', 'hover:to-red-600', 'hover:border-red-400');

      cleanButtonIcons(audioModeBtn);
      cleanButtonIcons(videoModeBtn);

      const audioCheckIcon = createCheckIcon();
      const playIcon = createPlayIcon();

      addIconToButton(audioModeBtn, audioCheckIcon);
      addIconToButton(videoModeBtn, playIcon);

      const audioTextSpan = audioModeBtn.querySelector('span:last-child');
      const videoTextSpan = videoModeBtn.querySelector('span:last-child');

      if (audioTextSpan) audioTextSpan.textContent = 'Audio';
      if (videoTextSpan) videoTextSpan.textContent = 'Vidéo';

      if (audioContainer) {
        audioContainer.style.opacity = '0';
        audioContainer.classList.remove('hidden');
        setTimeout(() => {
          audioContainer.style.opacity = '1';
        }, 50);
      }

      if (youtubeContainer) {
        youtubeContainer.style.opacity = '0';
        setTimeout(() => {
          youtubeContainer.classList.add('hidden');
        }, 300);
      }

      if (!currentPlayer && mainAudio) {
        initPlayer(mainAudio, hasMultipleParts ? 'Première partie' : '');
      }
    });
  }

  if (youtubePlaceholder && youtubeIframe) {
    youtubePlaceholder.addEventListener('click', () => {
      const youtubeId = youtubePlaceholder.dataset.youtubeId;

      if (youtubeId) {
        youtubeIframe.src = `https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&rel=0&modestbranding=1`;

        youtubePlaceholder.classList.add('hidden');
        youtubeIframe.classList.remove('hidden');
      }
    });
  }

  if (audioModeBtn && !audioModeBtn.querySelector('.check-icon')) {
    const initialPodcastIcon = createPodcastIcon();
    addIconToButton(audioModeBtn, initialPodcastIcon);
  }

  if (videoModeBtn && !videoModeBtn.querySelector('.check-icon') && !videoModeBtn.querySelector('span[class*="bg-red-600"]')) {
    const initialPlayIcon = createPlayIcon();
    addIconToButton(videoModeBtn, initialPlayIcon);
  }
});
